<template>
<div ref="models">
    <a-modal :title="'提示'" width="325px" v-model:visible="dialogVisible" centered :footer="null">
        <div v-if="type === '1'">
            <div style="margin-bottom:8px">恭喜您！<span class="allRedColor">尊贵的超级会员</span></div>
            <div style="margin-bottom:8px">感谢您的加入！您是第<span class="allRedColor">【{{curNum+1}}】</span>位开通的会员，幸运地位居前1000名之内，已自动为您解锁超级会员尊贵身份！</div>
            <div>您将永久专享：<span class="allRedColor">每年立省699元的超值会籍。</span></div>
        </div>
        <div v-if="type === '2'">
            <!-- 已过期会员提醒 -->
            <div v-if="expired30DaysMembers.length > 0" style="margin-bottom:16px;">
                <div style="margin-bottom:8px;">
                    亲爱的用户，您的
                    <span style="color: #ff4d4f; font-weight: bold;">
                        {{ expired30DaysMembersText }}
                    </span>
                    身份已过期<span class="allRedColor">{{ firstExpiredDays }}</span>天，请尽快续费。
                </div>
                <div style="text-align: center; margin-top: 18px;">
                    <a-button type="primary" @click="openRenew()">立即续费恢复权益</a-button>
                </div>
            </div>
            
            <!-- 即将在指定天数后到期的会员提醒 -->
            <div v-if="expiringSuperMembers.length > 0 && expired30DaysMembers.length === 0" style="margin-bottom:8px; text-align: center;">
                亲爱的超级会员，您尊贵的身份即将在<span class="allRedColor">{{ firstSuperMemberDaysLeft }}</span>天后到期。续费即可延续您的超级特权，千万别错过哦！
            </div>
            <div v-else-if="expiringNormalMembers.length > 0 && expired30DaysMembers.length === 0" style="margin-bottom:8px">
                亲爱的用户，您的
                <span style="margin-bottom:8px; color: #ff4d4f; font-weight: bold;">
                    {{ expiringMembersText }}
                </span>
                身份即将在<span class="allRedColor">{{ firstNormalMemberDaysLeft }}</span>天后到期。为了不让您错过任何专属权益，记得及时续费哦！
            </div>
            
            <!-- 如果只有已过期的会员，不显示此按钮 -->
            <div v-if="expiringVipMembers.length > 0 && expired30DaysMembers.length === 0" style="text-align: center; margin-top: 16px;">
                <a-button type="primary" @click="openRenew()">立即续费</a-button>
            </div>
            
            <!-- 如果没有到期提示，显示默认消息 -->
            <div v-if="!hasExpiringMembers" style="margin-bottom:8px; text-align: center; color: #666;">
                暂无会员到期提醒
            </div>
        </div>
    </a-modal>
    <renew ref="renewRef" v-model:visible="renewVisible" :renewActive="''"></renew>
</div>
</template>

<script>
import { list } from '@/mixins/list'
import renew from '@/components/renew'
import { dialog } from '@/mixins/dialog'

export default {
    props: {
        allNum: {
            type: Number,
            default: 0
        },
        curNum: {
            type: Number,
            default: 0
        },
        // 弹窗的类型 1成功成为超级会员提示，2会员到期提醒
        type: {
            type: String,
            default: "1"
        }
    },
    mixins: [list, dialog],
    components: {
        renew
    },
    data() {
        return {
            renewVisible: false
        }
    },
    computed: {
        // 检查是否有任何到期会员
        hasExpiringMembers() {
            return this.expired30DaysMembers.length > 0 || 
                   this.expiringSuperMembers.length > 0 || 
                   this.expiringNormalMembers.length > 0
        },
        
        // 计算已过期30天的会员（过期天数在30天以内）
        expired30DaysMembers() {
            if (!this.user.openMember || !Array.isArray(this.user.openMember)) {
                return []
            }
            
            const today = new Date()
            today.setHours(0, 0, 0, 0)
            
            return this.user.openMember.filter(member => {
                // 检查是否有到期时间
                if (!member.expiryDate) return false
                
                // 将到期时间转换为Date对象
                const expiryDate = new Date(member.expiryDate)
                expiryDate.setHours(0, 0, 0, 0)
                
                // 计算过期天数
                const diffTime = today - expiryDate
                const daysExpired = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
                
                // 检查是否已过期且在30天以内（1-30天）
                return daysExpired > 0 && daysExpired <= 30
            }).map(member => {
                // 为每个会员计算具体的过期天数
                const expiryDate = new Date(member.expiryDate)
                expiryDate.setHours(0, 0, 0, 0)
                const today = new Date()
                today.setHours(0, 0, 0, 0)
                const diffTime = today - expiryDate
                const daysExpired = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
                
                return {
                    ...member,
                    expiredDays: daysExpired
                }
            })
        },
        
        // 获取第一个已过期会员的过期天数
        firstExpiredDays() {
            if (this.expired30DaysMembers.length === 0) {
                return 0
            }
            
            // 按过期天数升序排列，取第一个（即过期天数最小的）
            const sortedMembers = [...this.expired30DaysMembers].sort((a, b) => a.expiredDays - b.expiredDays)
            return sortedMembers[0].expiredDays
        },
        
        // 计算即将在30天内到期的超级会员
        expiringSuperMembers() {
            if (!this.user.openMember || !Array.isArray(this.user.openMember)) {
                return []
            }
            
            const today = new Date()
            const thirtyDaysLater = new Date()
            thirtyDaysLater.setDate(today.getDate() + 30)
            
            // 清除时间部分，只比较日期
            today.setHours(0, 0, 0, 0)
            thirtyDaysLater.setHours(0, 0, 0, 0)
            
            return this.user.openMember.filter(member => {
                // 检查是否是超级会员
                if (member.isvvip !== 1) return false
                
                // 检查是否有到期时间
                if (!member.expiryDate) return false
                
                // 将到期时间转换为Date对象
                const expiryDate = new Date(member.expiryDate)
                expiryDate.setHours(0, 0, 0, 0)
                
                // 检查是否在30天内到期（包含今天和30天后）
                return expiryDate >= today && expiryDate <= thirtyDaysLater
            }).map(member => {
                // 为每个会员计算剩余天数
                const expiryDate = new Date(member.expiryDate)
                expiryDate.setHours(0, 0, 0, 0)
                const today = new Date()
                today.setHours(0, 0, 0, 0)
                const diffTime = expiryDate - today
                const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
                
                return {
                    ...member,
                    daysLeft: daysLeft
                }
            })
        },
        
        // 计算即将到期的普通会员
        expiringNormalMembers() {
            if (!this.user.openMember || !Array.isArray(this.user.openMember)) {
                return []
            }
            
            const today = new Date()
            const thirtyDaysLater = new Date()
            thirtyDaysLater.setDate(today.getDate() + 30)
            
            // 清除时间部分，只比较日期
            today.setHours(0, 0, 0, 0)
            thirtyDaysLater.setHours(0, 0, 0, 0)
            
            return this.user.openMember.filter(member => {
                // 检查是否是普通会员（不是超级会员）
                if (member.isvvip === 1) return false
                
                // 检查是否有到期时间
                if (!member.expiryDate) return false
                
                // 将到期时间转换为Date对象
                const expiryDate = new Date(member.expiryDate)
                expiryDate.setHours(0, 0, 0, 0)
                
                // 检查是否在30天内到期（包含今天和30天后）
                return expiryDate >= today && expiryDate <= thirtyDaysLater
            }).map(member => {
                // 为每个会员计算剩余天数
                const expiryDate = new Date(member.expiryDate)
                expiryDate.setHours(0, 0, 0, 0)
                const today = new Date()
                today.setHours(0, 0, 0, 0)
                const diffTime = expiryDate - today
                const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
                
                return {
                    ...member,
                    daysLeft: daysLeft
                }
            })
        },
        
        // 所有即将到期的会员（超级+普通）
        expiringVipMembers() {
            return [...this.expiringSuperMembers, ...this.expiringNormalMembers]
        },
        
        // 获取第一个即将到期超级会员的剩余天数
        firstSuperMemberDaysLeft() {
            if (this.expiringSuperMembers.length === 0) {
                return 0
            }
            
            // 按剩余天数升序排列，取第一个（即剩余天数最小的，最早到期）
            const sortedMembers = [...this.expiringSuperMembers].sort((a, b) => a.daysLeft - b.daysLeft)
            return sortedMembers[0].daysLeft
        },
        
        // 获取第一个即将到期普通会员的剩余天数
        firstNormalMemberDaysLeft() {
            if (this.expiringNormalMembers.length === 0) {
                return 0
            }
            
            // 按剩余天数升序排列，取第一个（即剩余天数最小的，最早到期）
            const sortedMembers = [...this.expiringNormalMembers].sort((a, b) => a.daysLeft - b.daysLeft)
            return sortedMembers[0].daysLeft
        },
        
        // 已过期30天的会员文本
        expired30DaysMembersText() {
            if (this.expired30DaysMembers.length === 0) {
                return ''
            }
            
            return this.expired30DaysMembers
                .map(member => {
                    return member.memberTypeName || '未知会员'
                })
                .join('，')
        },
        
        // 即将到期的普通会员文本
        expiringMembersText() {
            if (this.expiringNormalMembers.length === 0) {
                return '暂无即将到期的会员'
            }
            
            return this.expiringNormalMembers
                .map(member => {
                    return member.memberTypeName || '未知会员'
                })
                .join('，')
        }
    },
    created() {
        console.log('所有会员列表:', this.user.openMember)
        
        // 如果有到期会员，打印查看
        if (this.hasExpiringMembers) {
            console.log('有到期会员提醒，弹窗将显示')
            
            if (this.expiringVipMembers.length > 0) {
                console.log('即将到期的超级会员:', this.expiringSuperMembers)
                console.log('即将到期的普通会员:', this.expiringNormalMembers)
                console.log('所有即将到期的会员:', this.expiringVipMembers)
                console.log('第一个超级会员剩余天数:', this.firstSuperMemberDaysLeft)
                console.log('第一个普通会员剩余天数:', this.firstNormalMemberDaysLeft)
            }
            
            if (this.expired30DaysMembers.length > 0) {
                console.log('已过期30天的会员:', this.expired30DaysMembers)
                console.log('第一个会员的过期天数:', this.firstExpiredDays)
            }
        } else {
            console.log('没有到期会员提醒，弹窗将不显示')
            // 如果没有到期会员，关闭弹窗
            this.dialogVisible = false
        }
    },
    mounted() {
        this.$nextTick(() => {
            console.log(this.$refs.models)
        })
    },
    methods: {
        init(){
            // 如果有到期会员，打印查看
            if (this.hasExpiringMembers) {
                console.log('有到期会员提醒，弹窗将显示')
                
                if (this.expiringVipMembers.length > 0) {
                    console.log('即将到期的超级会员:', this.expiringSuperMembers)
                    console.log('即将到期的普通会员:', this.expiringNormalMembers)
                    console.log('所有即将到期的会员:', this.expiringVipMembers)
                    console.log('第一个超级会员剩余天数:', this.firstSuperMemberDaysLeft)
                    console.log('第一个普通会员剩余天数:', this.firstNormalMemberDaysLeft)
                }
                
                if (this.expired30DaysMembers.length > 0) {
                    console.log('已过期30天的会员:', this.expired30DaysMembers)
                    console.log('第一个会员的过期天数:', this.firstExpiredDays)
                }
            } else {
                console.log('没有到期会员提醒，弹窗将不显示')
                // 如果没有到期会员，关闭弹窗
                this.dialogVisible = false
            }
        },
        // 打开续费弹窗
        openRenew() {
            this.dialogVisible = false
            this.renewVisible = true
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/common.less';

/deep/ .ant-modal-content {
    box-shadow: none !important;
    background-color: rgba(0, 0, 0, 0) !important;
}

.allRedColor {
    color: #ff4d4f;
    font-weight: bold;
}

.userText{
    display: block;
    width: 547px;
    height: 209px;
    margin: 0 auto;
    margin-top: 40px;
}

.hyNum{
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    font-style: italic;
    color: #ffffff;
    font-weight: bold;
    margin-bottom: 5px;
    .num{
        font-size: 36px;
        color: #FFE398;
    }
}

.userBtn{
    background: url('@/assets/Image/newUser/newUserBtn.png');
    background-size: cover;
    text-align: center;
    cursor: pointer;
    width: 140px;
    height: 42px;
    line-height: 42px;
    font-size: 16px;
    font-weight: 700;
    color: #892500;
    margin: 0 auto;
    border-radius: 20px;
    &:hover{
        box-shadow: 0px 1px 23px 0.9px rgba(216,216,216,0.60); 
    }
}

.clear{
    clear: both;
}
</style>